import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import { Box, TextField } from '@material-ui/core';

import BasicBreadcrumbs from '../../../components/organisms/basicBreadcrumbs/BasicBreadcrumbs';
import MainBody from '../../../components/templates/mainBody/MainBody';
import SearchBox from '../../../components/templates/searchBox/SearchBox';
import SearchSelectBox from '../../../components/atoms/searchSelectBox/SearchSelectBox';
import MailMagazineListDatatable from './MailMagazineListDatatable';
import SuccessSnackbar from '../../../components/atoms/successSnackbar/SuccessSnackbar';
import FormTitle from '../../../components/atoms/formTitle/FormTitle';
import urls from '../../../constants/urls';

import {
  actCallInitMailMagazineList,
  actCallApiMailMagazineList,
  actCallApiDeleteMailMagazine,
} from '../../../redux/setting/mailMagazineList/action';

class MailMagazineList extends Component {
  constructor(props) {
    super(props);

    this.breadcrumbsText = [
      { name: 'メールマガジン' },
    ];

    let isMain = false;
    let searchCondition = {
      page: 0,
      records: 10,
      title: '',
      store: '',
      status: '',
    };

    if (props.common.user) {
      isMain = props.common.user.main;
      searchCondition = {
        ...searchCondition,
        store: props.common.user.store,
      };
    }

    this.state = {
      isMain,
      selects: {
        stores: [],
        status: [],
      },
      datas: [],
      searchCondition,
      deleteSuccessSnackOpen: false,
      snackMessage: '',
    };
  }

  componentDidMount() {
    this.props.dispatch(actCallInitMailMagazineList());
    document.title = 'メールマガジン';

    const { searchCondition } = this.state;
    this.search(searchCondition);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.common.user !== this.props.common.user) {
      if (this.props.common.user) {
        this.setUser(this.props.common.user);
      }
    }
    if (prevProps.mailMagazines.datas !== this.props.mailMagazines.datas) {
      if (this.props.mailMagazines.datas) {
        this.setDatas(this.props.mailMagazines.datas);
      }
    }
    if (prevProps.mailMagazines.selects !== this.props.mailMagazines.selects) {
      if (this.props.mailMagazines.selects) {
        this.setSelects(this.props.mailMagazines.selects);
      }
    }
    if (prevProps.mailMagazines.isDeleteSuccess !== this.props.mailMagazines.isDeleteSuccess) {
      if (this.props.mailMagazines.isDeleteSuccess) {
        this.setState({
          deleteSuccessSnackOpen: true,
          snackMessage: '削除しました',
        });
        this.onSearch();
      }
    }
  }

  setUser(user) {
    const { searchCondition: prev } = this.state;
    const searchCondition = {
      ...prev,
      store: user.store,
    };
    this.setState({ isMain: user.main, searchCondition });
    this.search(searchCondition);
  }

  setSelects(selects) {
    this.setState({ selects });
  }

  setDatas(datas) {
    this.setState({ datas });
  }

  onChange = (event) => {
    const { name, value } = event.target;
    const { searchCondition: prev } = this.state;
    const searchCondition = {
      ...prev,
      [name]: value,
    };
    this.setState({ searchCondition });
  }

  onSearch = () => {
    const {
      searchCondition,
    } = this.state;
    this.search(searchCondition);
  }

  search = (searchCondition) => {
    const args = {
      ...searchCondition,
      storeId: searchCondition.store?.id ?? '',
      statusId: searchCondition.status?.code ?? '',
    };
    this.props.dispatch(actCallApiMailMagazineList(args));
  }

  onMailMagazineDetail = (_, id) => {
    this.props.history.push({
      pathname: urls.SETTING.MAIL_MAGAZINE_DETAIL,
      state: {
        detailId: id,
      },
    });
  }

  handleChangePage = (_, page) => {
    const { searchCondition: prev } = this.state;
    const searchCondition = {
      ...prev,
      page,
    };
    this.setState({ searchCondition });
    this.search(searchCondition);
  };

  handleChangeRowsPerPage = (e) => {
    const { value } = e.target;
    const { searchCondition: prev } = this.state;
    const searchCondition = {
      ...prev,
      records: value,
    };
    this.setState({ searchCondition });
    this.search(searchCondition);
  }

  handleDelete = (ids) => {
    this.props.dispatch(actCallApiDeleteMailMagazine(ids));
  }

  handleSuccessSnackbarClose = () => {
    this.setState({ deleteSuccessSnackOpen: false });
  }

  render() {
    const {
      selects,
      datas,
      isMain,
      searchCondition,
      deleteSuccessSnackOpen,
      snackMessage,
    } = this.state;

    return (
      <>
        <BasicBreadcrumbs breadcrumbs={this.breadcrumbsText} />
        <MainBody>
          <SearchBox onSearch={this.onSearch}>
            <Box width="80%">
              <FormTitle title="タイトル" />
              <TextField name="title" variant="outlined" fullWidth value={searchCondition.title} onChange={this.onChange} />
            </Box>
            <Box display="flex" mt={2}>
              <Box display={isMain ? '' : 'none'} width="30%" mr={2}>
                <FormTitle title="店舗" />
                <SearchSelectBox options={selects.stores} value={searchCondition.store} onChange={this.onChange} name="store" />
              </Box>
              <Box width="30%">
                <FormTitle title="ステータス" />
                <SearchSelectBox options={selects.status} value={searchCondition.status} onChange={this.onChange} name="status" />
              </Box>
            </Box>
          </SearchBox>
          <MailMagazineListDatatable
            datas={datas?.content || []}
            totalElements={datas?.totalElements ?? 0}
            page={searchCondition?.page ?? 0}
            rowsPerPage={searchCondition?.records ?? 10}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
            onClick={this.onMailMagazineDetail}
            onDelete={this.handleDelete}
            isMain={isMain}
          />
          <SuccessSnackbar
            open={deleteSuccessSnackOpen}
            handleClose={this.handleSuccessSnackbarClose}
            message={snackMessage}
          />
        </MainBody>
      </>
    );
  }
}
const mapStateToProps = (state) => ({ mailMagazines: state.mailMagazines, common: state.common });

export default withRouter(connect(mapStateToProps)(MailMagazineList));
